module.exports = __webpack_public_path__ + "img/hr-sand-decal-02.169f582f.png";